<template>
    <div
        class="login-page locale-font"
        :style="{'background-image': `url(${require('@/assets/login-bg.jpg')})`}">
        <div class="top-left-logo">
            <img src="@/assets/logo-trans.png" />
        </div>
        <div class="top-right-lang">
            <ChangeLang />
        </div>
        <v-card
            width="570"
            outlined>
            <div class="logo-container">
                <img src="@/assets/olaf-logo.png" />
            </div>
            <v-card-text class="card-input">
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation>
                    <v-text-field
                        :label="this.$vuetify.lang.t('$vuetify.login.username')"
                        v-model="username"
                        autocomplete="off"
                        :placeholder="this.$vuetify.lang.t('$vuetify.login.usernamePlaceHolder')"
                        :rules="usernameRules"
                    ></v-text-field>

                    <v-text-field
                        :label="this.$vuetify.lang.t('$vuetify.login.password')"
                        v-model="password"
                        :type="inputPasswordType"
                        :placeholder="this.$vuetify.lang.t('$vuetify.login.passwordPlaceHolder')"
                        v-on:keyup.enter="onSubmit()"
                        :append-icon="inputPasswordType === 'password' ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="toggleInputPasswordType()"
                        :rules="passwordRules"
                    ></v-text-field>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-row>
                    <v-col cols="12 flex-center">
                        <v-btn
                            class="mx-auto my-5"
                            width="264"
                            color="primary"
                            @click="onSubmit()">
                            {{ $vuetify.lang.t('$vuetify.login.login') }}
                        </v-btn>
                    </v-col>
                    <v-col cols="12 flex-center pt-0">
                        <span
                            class="forgot-pw"
                            @click="goToForgotPasswordPage()">
                            {{ $vuetify.lang.t('$vuetify.login.forgotPassword') }}
                        </span>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
        <div class="version">{{ version }}</div>
    </div>
</template>
<script>
import ChangeLang from '@/components/ChangeLang'

export default {
    name: 'login',

    components: {
        ChangeLang
    },

    data () {
        return {
            valid: true,
            username: '',
            password: '',
            loading: false,
            usernameRules: [
                v => !!v || this.$vuetify.lang.t('$vuetify.login.usernameRequired')
            ],
            passwordRules: [
                v => !!v || this.$vuetify.lang.t('$vuetify.login.passwordRequired')
            ],
            inputPasswordType: 'password', // password or text,
            version: null
        }
    },

    methods: {
        async onSubmit () {
            if (!this.$refs.form.validate()) {
                return
            }
            this.$store.dispatch('setLoading', true)

            const response = await this.axios.post('login', {
                username: this.username,
                password: this.password
            })

            if (response && response.data) {
                localStorage.setItem('jwt', response.data.access)
                localStorage.setItem('userId', response.data.userId)

                this.$store.dispatch('setLoading', false)

                this.$router.push({ name: 'Dashboard' }, () => {})
            }
        },

        toggleInputPasswordType () {
            if (this.inputPasswordType === 'password') {
                this.inputPasswordType = 'text'
            } else if (this.inputPasswordType === 'text') {
                this.inputPasswordType = 'password'
            }
        },

        goToForgotPasswordPage () {
            this.$router.push({ name: 'ForgotPassword' }, () => {})
        }
    },

    async beforeMount () {
        this.version = await this.$store.dispatch('getVersion')
    },

    watch: {
        '$vuetify.lang.current': {
            handler: function (after, before) {
                this.$utils.recheckValidate(this.$refs.form.inputs)
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.login-page {
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;

    .v-content {
        height: 100%;
    }
}
.card-input {
    padding: 0rem 5rem;
}
.logo-container {
    display: flex;
    justify-content: center;
    margin: 2rem 0;
}
.forgot-pw {
    margin-bottom: 1.5rem;
    cursor: pointer;
    color: #D76436;
    font-weight: 500;
}
.flex-center {
    display: flex;
    justify-content: center;
}
.version {
    position: fixed;
    bottom: 34px;
    right: 5%;
}
</style>
